export default __webpack_public_path__ + "static/media/qrcode.143ce0b5.svg";